import { Button } from '@one-thd/sui-atomic-components';
import React, { useState } from 'react';
import { GetTrackShipmentData, GetTrackYourTruckData, } from '../../../hooks/track-shipment-hooks';
import { getWindow } from '../../../utils/general';
import { getFulfillmentStatus } from '../util/FulfillmentStatus';
import { TrackShipmentError } from './TrackShipmentError';
import TrackShipmentModal from './TrackShipmentModal';
import { isGiftCardInFulfillmentGroup } from '../util/general';
export var TrackShipment = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    var _u = _a.buttonVariant, buttonVariant = _u === void 0 ? 'primary' : _u, orderId = _a.orderId, fulfillmentGroup = _a.fulfillmentGroup, fulfillmentType = _a.fulfillmentType, shipmentIndex = _a.shipmentIndex;
    var _v = getFulfillmentStatus(fulfillmentType), isFulfillmentSTHorBOSS = _v.isFulfillmentSTHorBOSS, isMA = _v.isMA, isFulfillmentBODFSorDFS = _v.isFulfillmentBODFSorDFS;
    var _w = useState(false), modalOpen = _w[0], setModalOpen = _w[1];
    var handleModalClose = function () { return setModalOpen(false); };
    var _x = useState(false), defaultErrorFlag = _x[0], setDefaultErrorFlag = _x[1];
    // Regular Tracking API
    //  If any of these values are undefined then TrackShipment Button will be disabled.
    var providerCode = (_e = (_d = (_c = (_b = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.shippingAndHandling) === null || _b === void 0 ? void 0 : _b.shipments) === null || _c === void 0 ? void 0 : _c.shipment) === null || _d === void 0 ? void 0 : _d[shipmentIndex]) === null || _e === void 0 ? void 0 : _e.shippingProviderCode;
    var uniqueTrackingNumbers = (_h = (_g = (_f = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.shippingAndHandling) === null || _f === void 0 ? void 0 : _f.shipments) === null || _g === void 0 ? void 0 : _g.shipment) === null || _h === void 0 ? void 0 : _h.filter(function (obj, index) {
        var _a, _b, _c;
        return (index ===
            ((_c = (_b = (_a = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.shippingAndHandling) === null || _a === void 0 ? void 0 : _a.shipments) === null || _b === void 0 ? void 0 : _b.shipment) === null || _c === void 0 ? void 0 : _c.findIndex(function (obj2) { return (obj === null || obj === void 0 ? void 0 : obj.trackingNumber) === (obj2 === null || obj2 === void 0 ? void 0 : obj2.trackingNumber); })));
    });
    var trackingNumber = (_j = uniqueTrackingNumbers === null || uniqueTrackingNumbers === void 0 ? void 0 : uniqueTrackingNumbers[shipmentIndex]) === null || _j === void 0 ? void 0 : _j.trackingNumber;
    if ((trackingNumber === null || trackingNumber === void 0 ? void 0 : trackingNumber[0]) === '0') {
        trackingNumber = Number(trackingNumber !== null && trackingNumber !== void 0 ? trackingNumber : 0).toString();
    }
    var trackShipmentPayload = {
        orderNumber: orderId,
        providerCode: providerCode,
        trackingNumber: trackingNumber,
        applicationName: '',
    };
    var _y = GetTrackShipmentData(trackShipmentPayload), trackShipmentData = _y.trackShipmentData, trackShipmentError = _y.trackShipmentError, trackShipmentLoaded = _y.trackShipmentLoaded, handleTrackShipmentAPIButtonClick = _y.handleTrackShipmentAPIButtonClick;
    var trackShipmentForSTHAndBOSSFunction = function () {
        handleTrackShipmentAPIButtonClick();
        setModalOpen(true);
    };
    // FOR Major Appliance
    var trackShipmentForMajorAppliance = function () {
        var _a, _b, _c;
        var applianceDeliveries = (_a = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.shippingAndHandling) === null || _a === void 0 ? void 0 : _a.applianceDeliveries;
        if (isMA && applianceDeliveries) {
            var deliveryTrackerUrl = (_b = applianceDeliveries === null || applianceDeliveries === void 0 ? void 0 : applianceDeliveries[0]) === null || _b === void 0 ? void 0 : _b.deliveryTrackerUrl;
            (_c = getWindow()) === null || _c === void 0 ? void 0 : _c.open(deliveryTrackerUrl, '_blank');
        }
    };
    // FOR BODFS/DFS
    var bodfsDeliveries = (_k = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.bodfsDeliveryAndHandling) === null || _k === void 0 ? void 0 : _k.bodfsDeliveries;
    var name = "".concat(((_o = (_m = (_l = bodfsDeliveries === null || bodfsDeliveries === void 0 ? void 0 : bodfsDeliveries[0]) === null || _l === void 0 ? void 0 : _l.deliveryAddress) === null || _m === void 0 ? void 0 : _m.name) === null || _o === void 0 ? void 0 : _o.firstName) || '', " ").concat(((_r = (_q = (_p = bodfsDeliveries === null || bodfsDeliveries === void 0 ? void 0 : bodfsDeliveries[0]) === null || _p === void 0 ? void 0 : _p.deliveryAddress) === null || _q === void 0 ? void 0 : _q.name) === null || _r === void 0 ? void 0 : _r.lastName) || '').trim();
    var trackYourTruckPayload = {
        trackYourTruckRequest: {
            name: name,
            workOrderNumber: ((_s = bodfsDeliveries === null || bodfsDeliveries === void 0 ? void 0 : bodfsDeliveries[0]) === null || _s === void 0 ? void 0 : _s.workOrderNo) || '',
            orderNumber: orderId,
            capReservationId: ((_t = bodfsDeliveries === null || bodfsDeliveries === void 0 ? void 0 : bodfsDeliveries[0]) === null || _t === void 0 ? void 0 : _t.capacityReservationId) || '',
        },
    };
    var _z = GetTrackYourTruckData(trackYourTruckPayload), trackYourTruckData = _z.trackYourTruckData, trackYourTruckError = _z.trackYourTruckError, trackYourTruckLoaded = _z.trackYourTruckLoaded, handleTrackYourTruckAPICall = _z.handleTrackYourTruckAPICall;
    var trackShipmentForBODFSAndDFSFunction = function () {
        var _a;
        if (bodfsDeliveries) {
            // Track Your Truck
            handleTrackYourTruckAPICall();
            if (trackYourTruckData && trackYourTruckLoaded) {
                var trackerUrl = trackYourTruckData.trackerUrl;
                (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.open(trackerUrl, '_blank');
            }
            else if (trackYourTruckError && trackYourTruckLoaded) {
                setDefaultErrorFlag(true);
            }
        }
        setDefaultErrorFlag(true);
    };
    var handleOnClickForTrackShipment = function (event) {
        event.preventDefault();
        if (isFulfillmentSTHorBOSS) {
            trackShipmentForSTHAndBOSSFunction();
            return;
        }
        if (isMA) {
            trackShipmentForMajorAppliance();
            return;
        }
        if (isFulfillmentBODFSorDFS) {
            trackShipmentForBODFSAndDFSFunction();
            return;
        }
        setDefaultErrorFlag(true);
    };
    /*
  
        trackShipmentData is from the API and shipmentTrackingDetail is the inner object.
        when we define shippingProviderLogo with shipmentTrackingDetail it will be
        TypeError of null as trackShipmentData is only fetched when the button is clicked.
        hence we define {} for the null check
    */
    return (React.createElement(React.Fragment, null,
        (trackShipmentError || defaultErrorFlag) && (React.createElement(TrackShipmentError, null)
        /* NOTE:  TrackShipment Error is separated as a separated component even it seems to be static component but
       we might have to add other unhappy paths for other fulfillment types.
       */
        ),
        !isGiftCardInFulfillmentGroup(fulfillmentGroup) && (React.createElement("div", { className: "card-fix" },
            React.createElement(Button, { variant: buttonVariant, onClick: function (event) {
                    return handleOnClickForTrackShipment(event);
                } }, "Track Shipment"))),
        trackShipmentLoaded && trackShipmentData && (React.createElement(TrackShipmentModal, { modalOpen: modalOpen, handleModalClose: handleModalClose, shipmentTrackingDetail: trackShipmentData }))));
};
export default TrackShipment;
